import Disclaimer from "@components/Disclaimer";
import LayoutHeader from "@components/LayoutHeader";
import type { ParentProps } from 'solid-js'
import { Grid } from 'styled-system/jsx'
import Root from './root'

function Container(props: ParentProps) {
  return <Grid gap='0' gridTemplateRows='auto 1fr auto'>
    <LayoutHeader title='Dashboard' />
    {props.children}
    <Disclaimer />
  </Grid>
}

const routes = [
  {
    path: '/',
    component: Container,
    children: [
      {
        path: '/',
        component: Root,
      },
    ],
  },
]

export default routes
